import * as actions from './actionTypes';

export const notificationInit = data => ({
	type: actions.NOTIFICATION_INIT,
	payload: data,
});

export const notificationDismiss = data => ({
	type: actions.NOTIFICATION_DISMISS,
	payload: data,
});

export const handleNotifications = payload => ({
	type: actions.HANDLE_NOTIFICATIONS,
	payload,
});
